var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0859 17.4974C32.0859 14.6131 31.2306 11.7936 29.6282 9.39533C28.0258 6.99712 25.7482 5.12794 23.0834 4.02416C20.4187 2.92038 17.4864 2.63158 14.6575 3.19428C11.8287 3.75698 9.23015 5.14591 7.19064 7.18543C5.15112 9.22494 3.76219 11.8234 3.19949 14.6523C2.63679 17.4812 2.92559 20.4134 4.02937 23.0782C5.13314 25.743 7.00233 28.0206 9.40054 29.623C11.7988 31.2254 14.6183 32.0807 17.5026 32.0807C21.3699 32.0793 25.0784 30.5424 27.813 27.8078C30.5476 25.0732 32.0845 21.3647 32.0859 17.4974ZM12.3991 17.4974L18.9613 10.9351L21.0121 13.0063L16.521 17.4974L21.0121 21.9898L18.9613 24.0611L12.3991 17.4974Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left-icon.ee8f1ba297395acf1a4958c68b491a77.svg";
export { ForwardRef as ReactComponent };